import { useRef, useLayoutEffect, useMemo, useEffect } from 'react';

type Callback = (callback: () => void) => void;

// Inspired in https://github.com/ryuuji3/react-hooks/blob/4b183d61c30abf17efeab2240f8ff652a5dbb8e2/packages/use-callback-after-render/src/hooks/useCallbackAfterRender.ts
export const useCallbackAfterRender = (isLayout = false): Callback => {
  const lastRun = useRef<(() => void) | null>(null);

  const effect = useMemo(() => (isLayout ? useLayoutEffect : useEffect), [isLayout]);

  effect(() => {
    lastRun.current?.();
    lastRun.current = null;
  });

  return (callback) => {
    lastRun.current = callback; // schedule callback after render
  };
};
